import { render } from "./SentenceManager.vue?vue&type=template&id=8f986d08&scoped=true"
import script from "./SentenceManager.vue?vue&type=script&lang=js"
export * from "./SentenceManager.vue?vue&type=script&lang=js"

import "./SentenceManager.vue?vue&type=style&index=0&id=8f986d08&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f986d08"]])

export default __exports__